module.exports = __webpack_public_path__ + "b4e38bc731b909534a0a7d9e52117c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = 2012
// module chunks = 0